import React, { useEffect, useState, useMemo } from "react";
import {
  faArrowLeft,
  faEdit,
  faMagnifyingGlass,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import AddSubAdmin from "./AddSubAdmin";
import callApi from "services/api";
import { useRecoilState, useSetRecoilState } from "recoil";
import { UserState } from "global/UserState";
import { AlertState } from "global/AlertState";
import { loadingState } from "global/LoaderState";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const [showModal, setShowModal] = useState(false);
  const [, setAlertMessage] = useRecoilState(AlertState);
  const [user] = useRecoilState(UserState);
  const [empList, setEmpList] = useState([]);
  const loader = useSetRecoilState(loadingState);
  const [editingData, setEditingData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const navigate = useNavigate();
  const limit = 10;

  const handleOpenModal = (data = null) => {
    // setEditingData(data);
    setShowModal(true);
  };

  // const getEmployeeList = async (page = 1) => {
  //   try {
  //     loader(true);
  //     setLoading(true);
  //     setError(null);
  //     const params = new URLSearchParams({
  //       sort_order: '1',
  //       page: page.toString(),
  //       limit: limit.toString(),
  //     })
  //     let response = await callApi(
  //       `auth/users?${params}`,
  //       "GET",
  //       null,
  //       true,
  //       true,
  //       (msg) => setError(msg),
  //       (path) => console.log("navigate to", path)
  //     );

  //     if (response.success) {
  //       const body = response?.body || {}
  //       const employees = response?.body?.data || [];
  //       setCurrentPage(body.current_page || 1)
  //       setTotalPages(body.total_pages || 1)
  //       setTotalRecords(body.total_count || 0)

  //       const enrichedEmployees = await Promise.all(
  //         employees.map(async (emp) => {
  //           const unitData = emp.unit ? await getMasterdata(emp.unit) : null;
  //           const subUnitData = emp.subUnit
  //             ? await getMasterdata(emp.subUnit)
  //             : null;

  //           return {
  //             ...emp,
  //             unit: unitData?.name,
  //             subUnit: subUnitData?.name,
  //           };
  //         })
  //       );

  //       setEmpList(enrichedEmployees);
  //     }
  //   } catch (err) {
  //     setError(err.message || "Failed to load employees");
  //   } finally {
  //     loader(false);
  //     setLoading(false);
  //   }
  // };

  const getDashboardCount = async (page = 1) => {
    const params = new URLSearchParams({
      sort_order: "1",
      page: page.toString(),
      limit: limit.toString(),
    });
    let response = await callApi(
      `filtermaster/unit/details?${params}`,
      "GET",
      null,
      true,
      true,
      (msg) => setError(msg),
      (path) => console.log("navigate to", path),
    );
    if (response.success) {
      const body = response?.body || {};
      setEmpList(body?.data);
      setCurrentPage(body.current_page || 1);
      setTotalPages(body.total_pages || 1);
      setTotalRecords(body.total_count || 0);
    }
  };

  const handleView = (item, UnitName) => {
    // navigate("/delinquency", { state: { item ,UnitName} });
    navigate("/admin-unit", { state: { item, UnitName } });
  };

  useEffect(() => {
    // getEmployeeList();
    getDashboardCount();
  }, []);

  const renderRows = () => {
    if (!empList || empList?.length === 0) {
      return (
        <tr>
          <td colSpan={9} className="p-3 text-start">
            No Data
          </td>
        </tr>
      );
    }

    return empList?.map((item, index) => (
      <tr key={item.id}>
        <td className="text-center">{index + 1}</td>
        <td className="text-center">{item.name}</td>
        <td className="text-center">
          <span
            style={{
              fontWeight: item.deliquency_counts?.total > 0 ? "bold" : "normal",
            }}
          >
            {item.deliquency_counts?.total}
          </span>
        </td>
        <td className="text-center">
          <span
            style={{
              fontWeight: item.deliquency_counts.fir > 0 ? "bold" : "normal",
            }}
          >
            {item.deliquency_counts.fir}
          </span>
        </td>
        <td className="text-center">
          <span
            style={{
              fontWeight: item.deliquency_counts.de > 0 ? "bold" : "normal",
            }}
          >
            {item.deliquency_counts.de}
          </span>
        </td>
         <td className="text-center">
          <span
            style={{
              fontWeight: item.deliquency_counts.acr > 0 ? "bold" : "normal",
            }}
          >
            {item.deliquency_counts.acr}
          </span>
        </td>
        <td className="text-center">
          <button
            type="button"
            onClick={() => handleView(item.users[0]._id, item.name)}
            className="btn btn-sm btn-link me-2"
            style={{ textDecoration: "none", color: "blue" }}
          >
            <FontAwesomeIcon icon={faEdit} className="me-1" />
            View
          </button>
        </td>
      </tr>
    ));
  };

  return (
    <>
      <div className="container">
        <div className="ms-3 me-3 mt-3 d-flex justify-content-between bg-dark rounded ">
          <h5 className="card-title  p-3 m-0 text-white">Dashboard</h5>
        </div>
        <div className="card-body ms-3">
          <>
            <div className="mt-4 table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th className="text-center">S.no</th>
                    <th className="text-center">Unit</th>
                    <th className="text-center">Total Delinquencies</th>
                    <th className="text-center">Criminal Case</th>
                    <th className="text-center">Department Action</th>
                    <th className="text-center">Adverse Entry In ACR</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>{renderRows()}</tbody>
              </table>
            </div>
            <div className="d-flex justify-content-between align-items-center mt-3">
              <div>
                Page {currentPage} of {totalPages} | Total Records:{" "}
                {totalRecords}
              </div>

              <div>
                <button
                  disabled={currentPage === 1}
                  onClick={() => getDashboardCount(currentPage - 1)}
                  className="btn btn-sm btn-outline-primary me-2"
                >
                  Previous
                </button>

                <button
                  disabled={currentPage === totalPages}
                  onClick={() => getDashboardCount(currentPage + 1)}
                  className="btn btn-sm btn-outline-primary"
                >
                  Next
                </button>
              </div>
            </div>
            {/* {
            <AddSubAdmin
              showModal={showModal}
              handleCloseModal={handleCloseModal}
              editingData={editingData}
              fetchEmployees={getEmployeeList}
            />
          } */}
            {/* <AddEmployee
               showModal={showModal}
               fetchEmployees={getEmployeeList}
               handleCloseModal={handleCloseModal}
               editingData={editingData}
             /> */}
          </>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
